import { createSlice } from '@reduxjs/toolkit'
import { FirewallEntriesServerData, FirewallRule } from '@lk/api'

import { loadFirewall, setFirewallFilterRule } from './firewall.actions'
import { FIREWALL_DEFAULT_RULE } from './firewall.constants'

export interface SecurityFirewallState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  list: FirewallEntriesServerData
  rule: FirewallRule
}

const initialState: SecurityFirewallState = {
  status: 'idle',
  error: null,
  list: [],
  rule: FIREWALL_DEFAULT_RULE,
}

export const firewallReducer = createSlice({
  name: 'securityUsers',
  initialState,
  reducers: {},
  extraReducers: {
    [loadFirewall.pending.toString()]: (state) => {
      state.status = 'loading'
      state.list = []
    },
    [loadFirewall.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.list = action.payload
    },
    [loadFirewall.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
      state.list = []
    },
    [setFirewallFilterRule.toString()]: (state, action) => {
      state.rule = action.payload
    },
  },
}).reducer
